// Currency + date formatting. CLP has no minor units, so amounts are plain
// integers; we just group thousands per the active locale and prefix "$".

function pad2(n: number): string {
  return n.toString().padStart(2, "0");
}

/** Builds a Date at *local* midnight for an ISO `YYYY-MM-DD` string, so the
 * weekday/day come out right regardless of the browser timezone. */
function localDate(iso: string): Date {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function formatCLP(value: number, locale: string): string {
  return `$${value.toLocaleString(locale)}`;
}

/** Like formatCLP but renders 0 as the supplied "free" label. */
export function formatPrice(
  value: number,
  locale: string,
  freeLabel: string
): string {
  return value <= 0 ? freeLabel : formatCLP(value, locale);
}

export function formatDateLong(iso: string, locale: string): string {
  return localDate(iso).toLocaleDateString(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}

/** ISO strings for the next `n` days starting today (local time). */
export function upcomingDates(n: number): string[] {
  const out: string[] = [];
  const now = new Date();
  for (let i = 0; i < n; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
    out.push(
      `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
    );
  }
  return out;
}

export type DateParts = { weekday: string; day: string; month: string };

export function dateParts(iso: string, locale: string): DateParts {
  const d = localDate(iso);
  return {
    weekday: d.toLocaleDateString(locale, { weekday: "short" }),
    day: d.toLocaleDateString(locale, { day: "numeric" }),
    month: d.toLocaleDateString(locale, { month: "short" }),
  };
}
